import React from 'react';
import PropTypes from 'prop-types';
import Card from './card/card';
import { testAttributes } from '../../../Constants';
import * as Classes from './widget.module.scss';

const Widget = ({ data, articleId = null }) => 
{
    const renderCards = () =>
        data.map((item, index) => (
            <Card item={item} index={index} key={item.id} articleId={articleId} />
        ));
    return (
        <section
            className={Classes.widgets}
            data-testid={testAttributes.MULTIPLE_CTA_WIDGET}
        >
            {renderCards()}
        </section>
    );
};

export default Widget;
Widget.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            subtitle: PropTypes.string.isRequired,
            ctaButtonText: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        })
    ),
    articleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
